import React from 'react';
import styles from '../styles/ProductCardSkeleton.module.css';

export const ProductCardSkeleton = () => {
  return (
    <div className={styles.cardWrapper}>
      <div className={styles.card}>
        <div className={styles.image} />
        <div className={styles.content}>
          <div className={styles.category} />
          <div className={styles.title} />
          <div className={styles.price} />
          <div className={styles.price} />
          <div className={styles.price} />
          <div className={styles.description} />
          <div className={styles.description} />
          <div className={styles.actions}>
            <div className={styles.qty} />
            <div className={styles.button} />
          </div>
        </div>
      </div>
    </div>
  );
};
